import React from 'react'
import { render, screen } from '@testing-library/react'
import BasicTestimonialCard from '../BasicTestimonialCard'
import { BasicTestimonialCardProps } from '../types.d'

const baseProps: BasicTestimonialCardProps = {
  icon: [
    {
      url: 'https://placehold.co/600x400'
    }
  ],
  sectionHeading: 'Section Heading Basic Testimonial',
  displayName: 'John Doe',
  ctaLabel: 'Founder',
  restaurantName: 'Test Restaurant'
}

describe('Basic Testimonial Card Tests', () => {
  it('Should Render Basic Testimonial Card', () => {
    render(<BasicTestimonialCard {...baseProps} />)

    expect(screen.getByTestId('mds-basic-testimonial-card')).toBeTruthy()
  })
})
